import React from 'react';
import { PropTypes as PT } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import SVG from 'react-inlinesvg';
import alertIcon from '@lifesize/ux-assets/vectors/svgIcons/alert.svg';
import classes from './NotificationLostConnection.module.scss';
import notificationClasses from '../Notification/Notification.module.scss';

/**
 * Notification Lost Connection
 */
class NotificationLostConnection extends React.PureComponent  {
  render() {
    if (this.props.isCallActive || (!this.props.isCallDropped && this.props.isOffline) || !this.props.isReconnecting) {
      return null;
    }
    return (
      <ul className={`${notificationClasses.container} ${notificationClasses.blockingNotification}`}>
        <li>
          <div className={classes.container}>
            <div className={classes.content}>
              <div className={classes.notificationIcon}>
                <SVG src={alertIcon} data-testid="alertIcon" />
              </div>
              <div className={classes.message}>
                <FormattedMessage
                  id="components.notifications.lostConnection.message"
                  defaultMessage="Just a moment… we’re waiting for your internet to reconnect."
                />
              </div>
            </div>
          </div>
        </li>
      </ul>
    );
  }

}

NotificationLostConnection.propTypes = {
  isReconnecting: PT.bool.isRequired,
  isCallDropped: PT.bool.isRequired,
  isOffline: PT.bool.isRequired,
  isCallActive: PT.bool.isRequired
};

export default NotificationLostConnection;
